export class DataModelConnectionClient {
    lienMDP: string = "";
    code: string = "";
}